import { render, staticRenderFns } from "./emoji-dialog-mobile.vue?vue&type=template&id=dee06cee&scoped=true"
import script from "./emoji-dialog-mobile.vue?vue&type=script&lang=ts"
export * from "./emoji-dialog-mobile.vue?vue&type=script&lang=ts"
import style0 from "./emoji-dialog-mobile.vue?vue&type=style&index=0&id=dee06cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee06cee",
  null
  
)

export default component.exports